<template>
  <!-- <div> -->
  <td :colspan="colspan" :rowspan="rowspan" :class="{ disabled: disabled, diffentVal: showTip, diffentDisabled: disabled && showTip }">
    <!-- @keyup="inputChange" -->
    <el-tooltip v-if="showTip && status" :disabled="!showTip" :content="`${content}${dbVal}`" :placement="placement" effect="dark">
      <p @click="showInput">{{ nowAmount }}</p>
    </el-tooltip>
    <p v-else-if="!showTip && status" @click="showInput">{{ nowAmount }}</p>
    <input ref="inputVal" v-else :disabled="disabled" v-model="innerValue" @blur="inputChange($event)" type="text">
  </td>
  <!-- </div> -->

  <!--  <qzf-td :disabled="false" :amount.sync="cslist[0].amount" @change="changeList()"></qzf-td>
    <qzf-td :disabled="true" :amount.sync="cslist[1].amount" @change="changeList()"></qzf-td> -->

</template>
<script>
// 金额添加千分位
const comdify = function (n, isInteger) {
  if (!n) return n;
  let str = n.split('.');
  let re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = str[0].replace(re, "$&,");
  str = str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
  if(isInteger) {
    str = Number(str) ? Number(str).toFixed() : '';
  }
  return str;
};
//去除千分位中的‘，’
const delcommafy = function (num) {
  if (!num) return num;
  num = num.toString();
  num = num.replace(/,/gi, '');
  return num;
};
// 获取输入框的值
const getInputValue = function (value, isInteger) {
  let inputVal = Number(value) || '';
  return comdify(delcommafy(inputVal), isInteger);
};

export default {
  props: {
    colspan: {
      type: Number,
      default: 1,
    },
    rowspan: {
      type: Number,
      default: 1,
    },
    amount: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showTip: {
      type: Boolean,
      default: false,
    },
    dbVal: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '税局：',
    },
    placement: {
      type: String,
      default: 'right',
    },
    isInteger: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nowAmount: function () {
      return getInputValue(this.amount, this.isInteger)
    },
    innerValue: {
      get() {
        return this.amount;
      },
      set(val) {
        //处理他输入不是数字的字符串
        let amount = delcommafy(val)
        amount = amount * 1 ? amount * 1 : 0
        this.$emit('update:amount', String(amount))
      },
    }
  },
  data() {
    return {
      status: true,
    };
  },
  methods: {
    inputChange() {
      if (this.amount && this.isInteger) {
        const amount = Number(this.amount).toFixed().toString();
        this.$emit('update:amount', amount);
      }
      this.$emit('change')
      this.status = true
    },
    showInput() {
      if (this.disabled) {
        return
      }
      this.status = false
      this.$nextTick(function () {
        this.$refs.inputVal.focus()
      })
    }
  }
};
</script>
<style lang="scss" scoped>
td {
  // width: 100%;
  // display: inline-block;
  border-right: 1px solid #c2c2c2;
  border-bottom: 1px solid #c2c2c2;
  line-height: 25px;
  padding: 0 !important;
  color: #333;
  font-size: 14px;
}

input {
  width: calc(100% - 22px);
  line-height: 24px;
  // padding: 0 6px;
  background: rgb(241, 249, 253);
  font-size: 14px;
  padding-right: 20px;
  text-align: right;
  outline: none;
  color: #333;
  border: none;
}

p {
  // display: inline-block;
  // width: calc(100% - 22px);
  line-height: 27px;
  height: 27px;
  //padding: 0 6px;
  font-size: 14px;
  padding-right: 20px;
  text-align: right;
  color: #333;
  overflow: hidden;
}

.disabled {
  background: rgb(239, 239, 239);
}
.diffentVal {
  background: #fad4d4 !important;
}
.diffentDisabled {
  background: #fad4d4 !important;
}
</style>
